module.exports = __webpack_public_path__ + "static/img/2.2760bfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/2.jpg
// module id = oAzZ
// module chunks = 1